import { bff, createBFFHandlers } from '~/framework/bff';
import { getServerSideMonolithClient } from '~/framework';
import { getUserManageTableColumns as getUserManageTableColumnsFromMonolith } from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

export async function getUserManageTableColumns(options: CommonRequestOptions) {
   return await getUserManageTableColumnsFromMonolith(options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);

      const result = await getUserManageTableColumnsFromMonolith({
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getUserManageTableColumnsFromClient = (): ReturnType<
   typeof getUserManageTableColumns
> => {
   return bff()
      .post('/users/getUserManageTableColumns')
      .then(response => response.data);
};
